import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Zap, ArrowLeft } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <div style={{backgroundColor: '#F7F8FA', color: '#1e293b'}} className="min-h-screen">
      {/* Navigation */}
      <nav style={{backgroundColor: '#ffffff'}} className="border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <span style={{color: '#1e293b'}} className="text-xl font-bold">SmartFacture AI</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" style={{color: '#475569'}}>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Retour
              </Button>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 style={{color: '#1e293b'}} className="text-3xl font-bold mb-8">Mentions Légales</h1>
        
        <div style={{backgroundColor: '#ffffff'}} className="rounded-2xl p-8 shadow-sm space-y-8">
          
          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">1. Éditeur du site</h2>
            <div style={{color: '#475569'}} className="space-y-2">
              <p><strong>SmartFacture</strong></p>
              <p>Site internet : <a href="https://smartfacture-ai.com" className="text-blue-600 hover:underline">https://smartfacture-ai.com</a></p>
              <p>Email : <a href="mailto:tigroo93@hotmail.fr" className="text-blue-600 hover:underline">tigroo93@hotmail.fr</a></p>
              <p>Responsable : Mr Bouhyana Mustapha</p>
              <p>Directeur de la publication : Mr Bouhyana Mustapha</p>
              <p>SIREN : 889 445 789</p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">2. Hébergement</h2>
            <div style={{color: '#475569'}} className="space-y-2">
              <p><strong>Emergent Labs</strong></p>
              <p>Site : <a href="https://emergentagent.com" className="text-blue-600 hover:underline">https://emergentagent.com</a></p>
            </div>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">3. Propriété intellectuelle</h2>
            <p style={{color: '#475569'}}>
              L'ensemble du contenu de ce site (textes, images, logos, logiciels) est protégé par le droit d'auteur 
              et appartient à SmartFacture AI ou à ses partenaires. Toute reproduction, représentation, modification, 
              publication ou adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">4. Limitation de responsabilité</h2>
            <p style={{color: '#475569'}}>
              SmartFacture AI s'efforce d'assurer l'exactitude des informations diffusées sur ce site. 
              Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations 
              mises à disposition. SmartFacture AI décline toute responsabilité pour toute imprécision, 
              inexactitude ou omission portant sur des informations disponibles sur ce site.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">5. Données personnelles</h2>
            <p style={{color: '#475569'}}>
              Pour toute information concernant le traitement de vos données personnelles, 
              veuillez consulter notre <Link to="/confidentialite" className="text-blue-600 hover:underline">Politique de Confidentialité</Link>.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">6. Cookies</h2>
            <p style={{color: '#475569'}}>
              Ce site utilise des cookies. Pour en savoir plus, consultez notre{' '}
              <Link to="/cookies" className="text-blue-600 hover:underline">Politique de Cookies</Link>.
            </p>
          </section>

          <section>
            <h2 style={{color: '#1e293b'}} className="text-xl font-semibold mb-4">7. Droit applicable</h2>
            <p style={{color: '#475569'}}>
              Les présentes mentions légales sont régies par le droit français. En cas de litige, 
              les tribunaux français seront seuls compétents.
            </p>
          </section>

          <p style={{color: '#94a3b8'}} className="text-sm mt-8">
            Dernière mise à jour : Février 2026
          </p>
        </div>
      </main>
    </div>
  );
};

export default MentionsLegalesPage;
